import { useEffect, useState, useMemo } from "react";
import { Layout } from "antd";
import { Sidebar } from "./Sidebar";
import { OverviewDashboard } from "./OverviewDashboard";
import { ProjectCharts } from "./ProjectChartsProps";
import { ProjectDetail } from "./ProjectDetail";
import { FolderFilesModal } from "./FolderFilesModal";
import { ParticipanteHome  } from '../InformeParticipante/Home';
import { processTreeData, getGlobalStats, getFilesByProjectAndFolder, getAllFiles } from "./processTreeData";
import { FileManagement } from "./FileManagement";
import { getInformeActasData } from '../../services/InformeActas/InformeActasService';
import { selectAppPermissions } from '../../store/auth/selectors';
import { useSelector } from 'react-redux';
const { Content, Sider } = Layout;

export default function Dashboard() {
  const [activeView, setActiveView] = useState("overview");
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [showFolderModal, setShowFolderModal] = useState(false);
  const [filesData, setFilesData] = useState(null);
  const [ocultarData, setOcultarData] = useState(false);
  const [loading, setLoading] = useState(true);
  const appName = 'informe-actas';
  const permissions = useSelector((state) => selectAppPermissions(state, appName));
  const permissionExport = permissions.priv_export === 'Y';

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true); // ← Activar loading
        const params = {
          ruta: 'actividad_21/tarea_214/indicador_30/medio_verificacion_25/',
          nivel: 5
        };
        const data = await getInformeActasData(params);
        setFilesData(data);
      } catch (err) {
        console.error(err);
        setFilesData({ tree: [] });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const hidenMenu = () => {
    setOcultarData(!ocultarData);
  }

  const folderFiles = useMemo(() => {
    if (!filesData || !filesData.tree || !selectedProject || !selectedFolder) return [];
    return getFilesByProjectAndFolder(
      filesData.tree,
      selectedProject,
      selectedFolder
    );
  }, [selectedProject, selectedFolder, filesData]);

  const allFiles = useMemo(() => {
    if (!filesData || !filesData.tree) return [];
    return getAllFiles(filesData.tree);
  }, [filesData]);

  const projectStats = useMemo(() => {
    if (!filesData || !filesData.tree) return {};
    return processTreeData(filesData.tree);
  }, [filesData]);

  const globalStats = useMemo(() => {
    if (!projectStats || Object.keys(projectStats).length === 0) return {};
    return getGlobalStats(projectStats);
  }, [projectStats]);

  const handleProjectClick = (projectName) => {
    setSelectedProject(projectName);
    setSelectedFolder(null);
    setActiveView("project-detail");
  };

  const handleFolderClick = (folderName) => {
    setSelectedFolder(folderName);
    setShowFolderModal(true);
  };

  const handleBackToProjects = () => {
    setSelectedProject(null);
    setSelectedFolder(null);
    setActiveView("projects");
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <div>Cargando datos...</div>
      </div>
    );
  }


  if (!filesData) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <div>Error al cargar los datos</div>
      </div>
    );
  }

  const renderContent = () => {
    switch (activeView) {
      case "overview":
        return (
          <OverviewDashboard
            globalStats={globalStats}
            projectCount={Object.keys(projectStats).length}
            hidenMenu={hidenMenu}
            ocultarData={ocultarData}
          />
        );

      case "projects":
        return (
          <ProjectCharts
            projectStats={projectStats}
            onProjectClick={handleProjectClick}
            hidenMenu={hidenMenu}
            ocultarData={ocultarData}
          />
        );

      case "project-detail":
        if (!selectedProject || !projectStats[selectedProject]) {
          return (
            <div style={{ textAlign: "center", padding: "3rem", color: "#888" }}>
              Proyecto no encontrado
            </div>
          );
        }

        return (
          <ProjectDetail
            project={projectStats[selectedProject]}
            onBack={handleBackToProjects}
            onFolderClick={handleFolderClick}
            hidenMenu={hidenMenu}
            ocultarData={ocultarData}
          />
        );

      case "files":
        return (
          <FileManagement allFiles={allFiles} projectStats={projectStats} hidenMenu={hidenMenu} ocultarData={ocultarData} permissionExport={permissionExport} />
        );

      case "participantes":
        return (
          <ParticipanteHome  hidenMenu={hidenMenu} ocultarData={ocultarData} />
        );

      default:
        return (
          <OverviewDashboard
            globalStats={globalStats}
            projectCount={Object.keys(projectStats).length}
            hidenMenu={hidenMenu}
            ocultarData={ocultarData}
          />
        );
    }
  };

  return (
    <div className="container">
      <div className="row mb-2 d-flex align-items-center">
        <div className="col-md-7 linea_separador mb-2 d-flex align-items-center">
          <div className="titulo_proyecto" style={{ flexBasis: '25%', flexGrow: 0 }}>
            <p>PROYECTO UTF <br /> COL 160 COL</p>
          </div>
          <div className="objeto" style={{ flexBasis: '75%', flexGrow: 0 }}>
            <p>
              Implementar actividades de desarrollo económico, derecho humano a la alimentación y fortalecimiento de capacidades
              institucionales, comunitarias y organizacionales que aporten al cierre de brechas y la transformación de los territorios PDET
            </p>
          </div>
        </div>
        <Layout style={{ minHeight: "100vh" }}>
          {!ocultarData && (
            <Sider width={250} style={{ background: "#fff", borderRight: "1px solid #f0f0f0" }}>
              <Sidebar activeView={activeView} onViewChange={setActiveView} />
            </Sider>
          )}

          <Layout>
            <Content style={{ paddingLeft: "24px", overflowY: "auto" }}>
              {renderContent()}
            </Content>
          </Layout>
          {selectedProject && selectedFolder && (
            <FolderFilesModal
              isOpen={showFolderModal}
              onClose={() => setShowFolderModal(false)}
              projectName={selectedProject}
              folderName={selectedFolder}
              files={folderFiles}
              permissionExport={permissionExport}
            />
          )}
        </Layout>
      </div>
    </div>
  );
}